<section>
  <div class="player-selector">
    <app-player-search-bar
      placeholder="Buscar en videos..."
      ></app-player-search-bar>
    <div class="player-list">
      <app-player-list-card
        *ngFor="let player of players"
        class="player-item"
        [playerListItem]="player"
        [isSelected]="player?.id === selectedPlayer?.id"
        (playerClick)="onPlayerSelected($event)"
      >
      </app-player-list-card>
    </div>
  </div>
  <div class="player-selection-content">
    <ng-content> </ng-content>
  </div>
</section>
